import React, { useEffect } from "react";
import { useFormContext, useFieldArray, Controller } from "react-hook-form";
import { Row, Col, Button, Input, FormFeedback } from "reactstrap";
import CustomLabel from "../CustomLabel";

const ContentFormRepeater = ({ data, route }) => {

  const { control, errors, setValue } = useFormContext();
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "formRows2",
  });

  useEffect(() => {
    if (route === "edit") {
      if (data && data.length > 0) {
        replace(data.map((item) => ({ content: item?.content })));
      } else {
        append({
          content: "",
        });
      }
    }
  }, [data, replace]);

  useEffect(() => {
    if (fields.length === 0 && route === "add") {
      append({
        content: "",
      });
    }
  }, [route, data, append, fields.length]);

  return (
    <>
      {fields.map((field, index) => (
        <Row key={field.id} className="mb-3">
          <Col lg={10}>
            <CustomLabel htmlFor={`formRows2[${index}].content`} isRequired>
             Payment description
            </CustomLabel>
            <Controller
              name={`formRows2[${index}].content`}
              control={control}
              render={({ field }) => (
                <Input
                  type="textarea"
                  {...field}
                  invalid={!!errors.formRows2?.[index]?.content}
                  placeholder="Enter Your content"
                />
              )}
            />
            {errors.formRows2?.[index]?.content && (
              <FormFeedback>
                {errors.formRows2[index].content.message}
              </FormFeedback>
            )}
          </Col>
          {index > 0 && (
            <Col lg={2} className="align-self-center mt-4">
              <Button
                type="button"
                className="btn btn-danger"
                onClick={() => remove(index)}
              >
                Delete
              </Button>
            </Col>
          )}
        </Row>
      ))}
      <Button
        type="button"
        className="btn btn-info mt-3 mb-3 "
        onClick={() =>
          append({
            content: "",
          })
        }
      >
        Add
      </Button>
    </>
  );
};

export default ContentFormRepeater;
